<template>
  <v-navigation-drawer
    app
    :value="value"
    :mini-variant="!isMobile ? mini : false"
    :mini-variant-width="80"
    :absolute="isMobile"
    :temporary="isMobile && value"
    :permanent="!isMobile"
    dark
    @input="update">
    <template v-slot:prepend>
      <v-list-item class="head-branding">
        <v-list-item-avatar
          v-if="!mini || isMobile"
          id="branding"
          min-width="150"
          max-width="150">
          <router-link :to="{name: 'Home'}">
            {{ brandName }}
          </router-link>
        </v-list-item-avatar>
        <v-btn
          v-if="isMobile"
          class="btn-collect-menu"
          icon
          @click.stop="update(false)">
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
        <v-btn
          v-else
          class="btn-collect-menu"
          icon
          @click.stop="mini = !mini">
          <v-icon>mdi-menu</v-icon>
        </v-btn>
      </v-list-item>
    </template>

    <v-list
      dense
      nav>
      <v-list-item-group
        v-for="item in items"
        :key="item.title">
        <v-list-group
          v-if="item.subMenus"
          :prepend-icon="item.icon"
          no-action>
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </template>
          <list-menu
            v-for="subMenu in item.subMenus"
            :key="`${item.title}-${subMenu.title}`"
            :title="subMenu.title"
            :to="subMenu.to"
            :icon="subMenu.icon"
            icon-prepend />
        </v-list-group>
        <list-menu
          v-else
          :title="item.title"
          :to="item.to"
          :icon="item.icon"
          icon-prepend />
      </v-list-item-group>
    </v-list>

    <template v-slot:append>
      <v-divider />
      <div class="d-flex justify-space-between pa-2">
        <v-btn
          :text="!mini || isMobile"
          :icon="mini && !isMobile"
          small
          @click="logout()">
          <v-icon :class="{ 'mr-1': !mini || isMobile }">
            mdi-logout
          </v-icon>
          <span v-if="!mini || isMobile">
            ออกจากระบบ
          </span>
        </v-btn>
        <v-btn
          icon
          small
          @click="$emit('darkMode', !darkMode)">
          <v-icon>
            {{ iconTheme }}
          </v-icon>
        </v-btn>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import listMenu from '@/components/menu/list-menu'

export default {
  components: {
    listMenu
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    darkMode: {
      type: Boolean,
      required: true
    },
    value: {
      type: Boolean,
      required: true
    },
    isMobile: {
      type: Boolean,
      required: true
    },
    brandName: {
      type: String,
      required: false,
      default: ''
    }
  },
  data () {
    return {
      mini: false
    }
  },
  computed: {
    iconTheme () {
      if (this.$vuetify.theme.dark) {
        return 'mdi-white-balance-sunny'
      }
      return 'mdi-moon-waning-crescent'
    },
    brandingTheme () {
      return this.$vuetify.theme.dark
    }
  },
  methods: {
    update (value) {
      this.$emit('input', value)
    },
    logout () {
      this.$emit('logout', true)
    }
  }
}
</script>

<style scoped>
div.head-branding {
  height: 64px;
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
}
div.head-branding a {
  color: #ffffff;
  text-decoration: unset;
}
div#branding {
  border-radius: 0;
}
button.v-btn.btn-collect-menu {
  position: absolute;
  right: 20px;
}
</style>
